import React, { useState, useEffect } from "react";
import {Modal, Button, Skeleton, Table} from "antd";

const OrderItemNotShipped = (props) => {

  const orderDetailColumns = [
    {
      title: "Images",
      render: (image) => {return image?(<img alt="Profile Image" src={image} />):(<Skeleton.Image active />)},
      dataIndex: "image",
      key: "image",
    },
    { title: "Items", dataIndex: "name", key: "name", },
    { title: "Ordered Qty", dataIndex: "quantity", render: (_, record) => record.bundle_qty ?? record.quantity,},
    { title: "Item not shipped", dataIndex: "item_not_shipped", key: "item_not_shipped"},
    {
      title: "Price",
      dataIndex: "price",
      render: (_, record) => {
          return record.unit_discount && record.unit_discount > 0 ? record.unit_discount : record.price;
      }
    },
    {
      title: "Total Price",
      dataIndex: "price",
      render: (_, record) => {
        const currentPrice = record.unit_discount && record.unit_discount > 0 ? record.unit_discount : record.price;
        return (currentPrice * record.item_not_shipped).toFixed(2);
      }
    },
  ];

  const handleCancel = () => {props.setvisible(false)};

  const rawItems =
    props.orderData &&
    props.orderData[0] &&
    props.orderData[0].order_details &&
    props.orderData[0].order_details.order_items
      ? props.orderData[0].order_details.order_items
      : [];

  const filteredItems = [];

  rawItems.forEach(item => {
    const itemNotShipped = parseInt(item.item_not_shipped);

    // Include the main order item if not shipped
    if (!isNaN(itemNotShipped) && itemNotShipped > 0) {
      filteredItems.push(item);
    }

    // If it's a bundle, check each bundle item
    if (Array.isArray(item.bundle_details)) {
      item.bundle_details.forEach(bundleItem => {
        const bundleNotShipped = parseInt(bundleItem.item_not_shipped);
        if (!isNaN(bundleNotShipped) && bundleNotShipped > 0) {
          filteredItems.push(bundleItem);
        }
      });
    }
  });

  return (
    <Modal
      title="Order Item Not Shipped"
      visible={props.visible}
      onCancel={handleCancel}
      width={"75%"}
      footer={[
        <Button onClick={handleCancel}>Cancel</Button>,
      ]}
    >
      <Table
        dataSource={filteredItems}
        columns={orderDetailColumns}
        pagination={false}
      />
    </Modal>
  );
};

export default OrderItemNotShipped;
